import React from "react";

// Reusable animated highway / route line that threads down the site.
export const RouteLine = ({ className = "", height = 160 }) => (
  <div className={`relative w-full flex justify-center ${className}`} aria-hidden>
    <svg width="100%" height={height} viewBox={`0 0 1200 ${height}`} preserveAspectRatio="none" className="overflow-visible">
      <path
        d={`M600 0 C 560 ${height * 0.3}, 680 ${height * 0.5}, 600 ${height}`}
        fill="none" stroke="rgba(212,175,55,0.18)" strokeWidth="26" strokeLinecap="round"
      />
      <path
        d={`M600 0 C 560 ${height * 0.3}, 680 ${height * 0.5}, 600 ${height}`}
        fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" className="road-dash"
      />
    </svg>
  </div>
);

export const BackgroundGrid = ({ className = "" }) => (
  <div className={`pointer-events-none absolute inset-0 nm-grid-bg opacity-60 ${className}`} aria-hidden />
);

// decorative moving map nodes
export const NodeField = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
    {[...Array(6)].map((_, i) => (
      <span
        key={i}
        className="absolute w-1.5 h-1.5 rounded-full bg-[#2563EB] pulse-glow"
        style={{
          top: `${15 + ((i * 37) % 70)}%`,
          left: `${(i * 23) % 92}%`,
          animationDelay: `${i * 0.4}s`,
        }}
      />
    ))}
  </div>
);
